import liff from "@line/liff";
import { auth } from "./api";
import Swal from "sweetalert2";

const liffId = process.env.REACT_APP_LIFF_ID || "2006341336-XMNvwBgL";
console.log(liffId, "test") ;
export const initLiffApp = async () => {
  try {
    await liff.init({ liffId: liffId });
    if (liff.isLoggedIn()) {
      const profile = await liff.getProfile();
      return profile;
    } else {
      liff.login();
    }
  } catch (error) {
    console.error("LIFF initialization failed");
    return null;
  }
};

export const authentication = async (lineId, skip) => {
  try {
    const response = await auth(lineId);
    console.log(`authentication api: response ${JSON.stringify(response)}`);
    if (response.error) {
      await Swal.fire({
        title: "發生錯誤",
        text: JSON.stringify(response.data),
        icon: "error",
      });
      return { error: true, data: "error" };
      // go to error
    } else if (response.data === "no lineId") {
      await Swal.fire({
        title: "無法連接LINE帳號",
        text: "請重新登入或以其他帳號登入",
        icon: "error",
      });
      return { error: false, data: "no lineId" };
      // go to error
    } else if (response.data === "no user") {
      if (skip !== "no user") {
        await Swal.fire({
          title: "無此帳號",
          text: "請先註冊帳號",
          icon: "warning",
        });
      }
      return { error: false, data: "no user" };
      // go to /email
    } else if (response.data === "no vertification") {
      if (skip !== "no vertification") {
        await Swal.fire({
          title: "未驗證Email帳號",
          text: "請先至email信箱驗證email帳號",
          icon: "warning",
        });
      }

      return { error: false, data: "no vertification" };
      // go to /email
    } else {
      if (response.data.isCreated) return { error: false, data: response.data, created: true };
      // 驗證+已建立 go to /main
      else return { error: false, data: "vertified" };
      //驗證(未建立)  go to /register
    }
  } catch (error) {
    await Swal.fire({
      title: "發生錯誤",
      icon: "error",
    });
    return { error: true, data: "error" };
    // go to error
  }
};
